// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".similarProjects{padding-top:80px;position:relative}.similarProjects .mainTtl{font-size:34px;line-height:60px}.reasonsSliderContainer .descr{width:40%}.similarProjectsOut{margin-top:50px}", ""]);
// Exports
module.exports = exports;
